import React from 'react'
import interlude1 from '../images/Union (4).png';

const Interlude = () => {
  return (
    <div>
        <img src={interlude1} className="interlude1" alt="logo" />
    </div>
  )
}

export default Interlude